import { useState } from "react";
import checkIcon from "../../../../../../../../../utilities/images/package_course_modes/icon-check.svg";
import chevronIcon from "../../../../../../../../../utilities/images/package_course_modes/icon-chevron.svg";
import StoreMasteryUpgrade from "../StoreMasteryUpgrade/StoreMasteryUpgrade";
import "./StoreCourseDetails.scss";

const titlesFrom = (block) => {
  const list = Array.isArray(block) ? block : block?.features;
  if (!Array.isArray(list)) return [];
  return list
    .map((item, index) => {
      const title =
        typeof item === "string" ? item : item?.title || item?.name || "";
      const text = String(title).replace(/<[^>]+>/g, "").trim();
      if (!text) return null;
      return { id: item?.id ?? `${text}-${index}`, title: text };
    })
    .filter(Boolean);
};

const CheckList = ({ items, columns }) => (
  <div className={`course-details__card${columns === 2 ? " is-grid" : ""}`}>
    {items.map((item) => (
      <div key={item.id} className="course-details__row">
        <span className="course-details__check">
          <img src={checkIcon} alt="" />
        </span>
        <p>{item.title}</p>
      </div>
    ))}
  </div>
);

const QuestionList = ({ items }) => {
  const [openId, setOpenId] = useState(items[0]?.id ?? 0);

  return (
    <div className="course-details__questions">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id} className={`course-details__question${open ? " is-open" : ""}`}>
            <button
              type="button"
              className="course-details__question-toggle"
              aria-expanded={open}
              onClick={() => setOpenId(open ? null : item.id)}
            >
              <span>{item.title}</span>
              <img src={chevronIcon} alt="" className="course-details__chevron" />
            </button>
            {open && item.answer ? <p>{item.answer}</p> : null}
          </div>
        );
      })}
    </div>
  );
};

const StoreCourseDetails = ({ packageData }) => {
  const outcomes = titlesFrom(packageData?.learning_outcomes);
  const benefits = titlesFrom(packageData?.student_benefits);
  const outcomeSubtitle = packageData?.learning_outcomes?.subtitle || "";
  const benefitTitle = packageData?.student_benefits?.title || "Why Students Love Motion";
  const benefitSubtitle = packageData?.student_benefits?.subtitle || "";
  const notices = (packageData?.slider_text || [])
    .map((item) => String(item?.name || "").trim())
    .filter(Boolean);
  const questions = (packageData?.faq || [])
    .map((item, index) => ({
      id: item?.id ?? index,
      title: String(item?.name || "").trim(),
      answer: String(item?.description || "").replace(/<[^>]+>/g, "").trim(),
    }))
    .filter((item) => item.title);

  if (!outcomes.length && !benefits.length && !questions.length && !notices.length) {
    return null;
  }

  const marqueeText = notices.join("    ✦    ");

  return (
    <section className="course-details">
      {marqueeText ? (
        <div className="course-details__marquee">
          <div className="course-details__marquee-track">
            <span>{`✦    ${marqueeText}    ✦`}</span>
            <span aria-hidden="true">{`✦    ${marqueeText}    ✦`}</span>
          </div>
        </div>
      ) : null}

      {outcomes.length ? (
        <div className="course-details__block">
          <div className="course-details__heading">
            <h2>{packageData?.learning_outcomes?.title || "Learning Outcomes"}</h2>
            {outcomeSubtitle ? <p>{outcomeSubtitle}</p> : null}
          </div>
          <CheckList items={outcomes} />
        </div>
      ) : null}

      <StoreMasteryUpgrade packageData={packageData} />

      {benefits.length ? (
        <div className="course-details__block">
          <div className="course-details__heading">
            <h2>{benefitTitle}</h2>
            {benefitSubtitle ? <p>{benefitSubtitle}</p> : null}
          </div>
          <CheckList items={benefits} columns={2} />
        </div>
      ) : null}

      {questions.length ? (
        <div className="course-details__block">
          <h2 className="course-details__title">Got Questions?</h2>
          <QuestionList items={questions} />
        </div>
      ) : null}
    </section>
  );
};

export default StoreCourseDetails;
